module.exports = __webpack_public_path__ + "static/media/CoderGuides.075d0c92.webp";